import React from 'react';
import type { ElementType, ReactNode } from 'react';

import classnames from 'classnames';

import styles from './Chip.scss';

interface ChipProps {
    className?: string;
    Component?: ElementType;
    leftIcon?: ReactNode;
    onClick?: (e: React.MouseEvent) => void;
    rightIcon?: ReactNode;
    text: string;
}

function Chip(props: ChipProps) {
    const {
        Component = 'div',
        className = '',
        leftIcon,
        onClick = () => undefined,
        rightIcon,
        text,
        ...otherProps
    } = props;

    return (
        <Component
            className={classnames(
                className,
                styles.chip,
            )}
            onClick={onClick}
            {...otherProps}
        >
            {leftIcon && (
                <div className={styles.leftIcon}>
                    {leftIcon}
                </div>
            )}
            <span>{text}</span>
            {rightIcon && (
                <div className={styles.rightIcon}>
                    {rightIcon}
                </div>
            )}
        </Component>
    );
}

export default Chip;
